import {endpoint} from '~/api';
import {ID} from '~/lib/model';
import {IUser} from '~/modules/Users/models/User';
import {IUserPermission} from '~/modules/Users/models/UserPermission';


export const fetchUser = (id: string) => endpoint.get<IUser>(`/users/${id}`).then(response => response.data);
export const fetchUsers = () => endpoint.get<IUser[]>('/users').then(r => r.data);
export const createUser = (user: IUser) => endpoint.post<IUser>('/users', user).then(r => r.data);
export const updateUser = (user: IUser) => endpoint.post<IUser>(`/users/${user.id}`, user).then(r => r.data);
export const deleteUser = (id: ID) => endpoint.delete(`/users/${id}`);

export const createUserPermission = (
    permission: IUserPermission
) => endpoint.post('/permissions', permission).then(r => r.data);

export const deleteUserPermission = (
    permission: IUserPermission
) => endpoint.delete(`/users/${permission.userId}/permissions/${permission.resourceType}/resource/${permission.resourceId}`)
    .then(r => r.data);
